import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {isCurrentSlot} from 'src/app/store';

import {TimeSlot} from 'src/app/store/entities';

@Component({
  selector: 'mwo-setlist-planning',
  templateUrl: './setlist-planning.component.html',
  styleUrls: ['./setlist-planning.component.scss']
})
export class SetlistPlanningComponent implements OnInit, OnChanges {
  @Input() activeDay: string;
  @Input() setlist: TimeSlot[];
  @Input() isPlayingFromSchedule: boolean;
  @Input() playlistMode = false;
  @Input() fromModifierPage = false;

  @Output() scheduleModeChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.setlist) {
      // the element may not be rendered yet
      setTimeout(() => {
        this.scrollToActiveItem();
      }, 0);
    }
  }

  scrollToActiveItem() {
    if (this.setlist.length >= 4) {
      const activeItemIndex = this.setlist.findIndex(item => isCurrentSlot(item));
      if (activeItemIndex >= 0) {
        const element = document.getElementById('item-' + activeItemIndex);
        element?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }


  getVisibleColor(timeSlot: TimeSlot): string {
    const timeslotColor = timeSlot.tempo ? timeSlot.tempo.color : timeSlot.event.color;
    return (timeslotColor === '#FFFFFF' || timeslotColor === 'white' || !timeslotColor)
      ? 'grey'
      : timeslotColor;
  }
}
